export class SendNoticeDto {
    public distributionId:number;
    public noticePersonalMessage:string;
    public noticeDate:Date;
    public metaFileLinkIds?: number[];
}